import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=e0652a42"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports